//@flow
import type { User } from 'core/data-model/identity'
import type { IdToken } from 'core/data-model/identity/types'
import RequestWrapper from 'e-submission/domain/data/request-wrapper'

export default {
  getRequest: (path: string, user: User | IdToken, params: Object, config: Object = {}) =>
    RequestWrapper.getRequest(path, user, params, config),
}
